import { render, staticRenderFns } from "./ModalDragAndDropMoverMultiplesDocumentos.vue?vue&type=template&id=1ab90bd3&scoped=true&"
import script from "./ModalDragAndDropMoverMultiplesDocumentos.vue?vue&type=script&lang=js&"
export * from "./ModalDragAndDropMoverMultiplesDocumentos.vue?vue&type=script&lang=js&"
import style0 from "./ModalDragAndDropMoverMultiplesDocumentos.vue?vue&type=style&index=0&id=1ab90bd3&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1ab90bd3",
  null
  
)

export default component.exports